export type TrackingIdentity = { sessionId: string; visitorId: string; consent: true };
const consentKey = "score-analytics-consent";
const visitorKey = "score-visitor-id";
const sessionKey = "score-session-id";

function createId() {
  return typeof crypto !== "undefined" && crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
}

export function analyticsConsent(): boolean | null {
  if (typeof window === "undefined") return null;
  const value = localStorage.getItem(consentKey);
  return value === null ? null : value === "granted";
}

export function setAnalyticsConsent(granted: boolean) {
  localStorage.setItem(consentKey, granted ? "granted" : "denied");
  window.dispatchEvent(new CustomEvent("score-consent-changed", { detail: granted }));
}

// A failed metric must never break the page, but swallowing the rejection in
// silence is how a permanently broken tracking endpoint went unnoticed in
// production. Warn instead, so the next failure is one console open away.
export function reportTrackingFailure(error: unknown) {
  if (typeof console !== "undefined") console.warn("[score-creator] evento de métrica não registrado:", error);
}

export function getTrackingIdentity(): TrackingIdentity | null {
  if (typeof window === "undefined" || analyticsConsent() !== true) return null;
  let visitorId = localStorage.getItem(visitorKey);
  let sessionId = sessionStorage.getItem(sessionKey);
  if (!visitorId) { visitorId = createId(); localStorage.setItem(visitorKey, visitorId); }
  if (!sessionId) { sessionId = createId(); sessionStorage.setItem(sessionKey, sessionId); }
  return { visitorId, sessionId, consent: true };
}
